(function (){
    'use strict';

    angular
        .module('services')
        .service('CompaniesService', CompaniesService);

    CompaniesService.$inject = ['$http', 'API_BASE'];

    function CompaniesService ($http, API_BASE) {
        var service = this;

        service.getByFilter = getByFilter;
        service.getAllForSelect = getAllForSelect;

        function getByFilter(filters) {
            return $http.get(API_BASE + '/invoice/companies', {params: filters});
        }

        function getAllForSelect() {
            return $http.get(API_BASE + '/invoice/companies/for_select');
        }

    }
})();